{
  "title": "Events",
  "subtitle_one": "{{count}} recent state change",
  "subtitle_other": "{{count}} recent state changes",
  "noSitesHint": "Events appear when the site's monitors change state. Start by creating a site and an agent.",
  "loadFailed": "Could not load the events",
  "loadFailedHint": "{{reason}} Check the connection to the server.",
  "emptyTitle": "No events yet",
  "emptyHint": "That is good news: not one monitor on this site has changed state. Records appear when a node stops answering or comes back.",
  "column": {
    "at": "Time",
    "node": "Node",
    "monitor": "Check",
    "transition": "Transition",
    "reason": "Reason"
  }
}
